function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
// Imports
import stringToBoolean from '@engine/lib/utility/parse_boolean';

var RiskFilterCurrentSettings = /*#__PURE__*/function () {
  function RiskFilterCurrentSettings(currentSettings, defaultSettings) {
    _classCallCheck(this, RiskFilterCurrentSettings);

    this.currentSettings = currentSettings;
    this.defaultSettings = defaultSettings;
    this.normalizedSettings = this.normalizeRawSettings();
  }

  _createClass(RiskFilterCurrentSettings, [{
    key: "normalized",
    get: function get() {
      return this.normalizedSettings;
    }
  }, {
    key: "normalizeRawSettings",
    value: function normalizeRawSettings() {
      var _this = this;

      var normalizedSettings = {};
      this.defaultSettings.forEach(function (setting) {
        var currentSettingValue = _this.currentSettings[setting.name];

        if (typeof currentSettingValue !== 'undefined') {
          if (setting.type === 'boolean' && typeof currentSettingValue === 'string') {
            normalizedSettings[setting.name] = stringToBoolean(currentSettingValue);
          } else if (setting.type === 'integer' || setting.type === 'float') {
            normalizedSettings[setting.name] = parseFloat(currentSettingValue);
          } else {
            normalizedSettings[setting.name] = _this.currentSettings[setting.name];
          }
        } else {
          normalizedSettings[setting.name] = setting["default"];
        }
      });
      return normalizedSettings;
    }
  }]);

  return RiskFilterCurrentSettings;
}();

export default RiskFilterCurrentSettings;